import { createContext } from 'react';

const NovoContext = createContext();

export const NovoProvider = NovoContext.Provider;
export const NovoConsumer = NovoContext.Consumer;

export default NovoContext;
